import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import { pageNotFound } from '@framework/router/Next/helpers';
import getServerSideStatBreadcrumbs from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideStatBreadcrumbs';
import getServerSideStat from '@/creditflowresearch/application/ArticlesAndStats/Stat/serverSide/getServerSideStat';
import StatContextProvider from '@/creditflowresearch/application/ArticlesAndStats/Stat';
import Stat from '@/creditflowresearch/ui/components/creditFlow/Stat';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const stat = await getServerSideStat(context);
  if ('notFound' in stat) {
    return pageNotFound();
  }
  const breadcrumbs = getServerSideStatBreadcrumbs(context, stat.name);

  return ({
    props: {
      stat,
      breadcrumbs,
    },
  });
}, { needsLegacyDictionaries: false });

export default ({ stat }) => (
  <StatContextProvider stat={ stat }>
    <PageContentLayout>
      <Stat />
    </PageContentLayout>
  </StatContextProvider>
);
